<div class="container-flutuante" [style.left]="navBarStatus?'265px':'5px'">
    <div class="card-chat card" [style.display]="activated?'':'none !important'">
        <div class="card-chat-header card-header">
            <ul>
                <li><button [disabled]="true" title="Em Breve!" class="btn-nav-chat">Suporte</button></li><!-- (click)="alterarChat(0)" -->
                <li><button *ngIf="chatOrcamentoDisponivel()" title="Chat do Orçamento aberto" (click)="alterarChat(1)" class="btn-nav-chat select">Chat
                        Orçamento</button></li>
                <li><button *ngIf="!chatOrcamentoDisponivel()" title="Abra um orçamento para ter acesso ao chat" class="btn-nav-chat select"
                        disabled="true">Chat Orçamento</button></li>
            </ul>
            <button class="btn" (click)="carregarMensagensOrcamento()"><i class="fa fa-reload"></i></button>
        </div>
        <div class="card-chat-body card-body">
            <div class="chat-content">
                <div class="chat-mensagens">
                    <div class="msg-div" *ngFor="let msg of listaMsg">
                        <div class="msg-box side-{{msg.side}}">
                            <div class="msg-content">
                                <strong class="msg-sender-name" [style.color]="retornaCorDoUsuario(msg.sender_name)">{{msg.sender_name}}</strong>
                                <span class="msg">{{msg.content}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="chat-send-div">
                    <div class="chat-sender">
                        <textarea id="msgSend" placeholder="Digite Aqui!"></textarea>
                        <button class="btn-send" title="Enviar Mensagem" (click)="enviar()" [disabled]="!chatOrcamentoDisponivel() && aba == 1"><i
                                class="fa fa-send"></i></button>
                    </div>
                    <hr class="hr-chat-send">
                </div>
            </div>
        </div>
    </div>
    <div class="ball-click" (click)="toggle()">
        <i class="fa fa-comments"></i>
    </div>
</div>